<script>
let users = [];

console.log("Head: " + firebase.auth().currentUser.email);

let refAllUserList;
let refTeachersList;
let refStudentByTeacherList = firebase.database().ref("edulearn/rules/userbyteacher");

let searchQuery = '' // bound to the input field

let mockCreatedDate = 1593333725140;

$: teachers = users.filter(u => u.isTeacher);
$: assignedUsers = users.filter(u => u.teacher);
$: usersFiltered = searchQuery 
    ? users.filter(u => u.email && u.email.includes(searchQuery)) 
    : users.sort((a, b) => (b.created || mockCreatedDate) - (a.created || mockCreatedDate));

let selected = 'none';

refAllUserList = firebase.database().ref("edulearn/users/list");
refAllUserList.on("child_added", function(snap) {
    let user = users.find(u => u.id == snap.val().id);
    if (user) {
        user = [...user, snap.val()];
        users = [...users];
    } else users = [...users, snap.val()];
});

refAllUserList.on("child_removed", function(snap) {
    users = users.filter(u => u.id != snap.val().id);
});

refTeachersList = firebase.database().ref("edulearn/rules/teachers");
refTeachersList.on("child_added", function(snap) {
    let user = users.find(u => u.id == snap.key);
    if (user) {
        user.isTeacher = true;
        users = [...users];
    } else {
        users = [...users, { id: snap.key, isTeacher: true }];
    }
});

refTeachersList.on("child_removed", function(snap) {
    let user = users.find(u => u.id == snap.key);
    if (user) {
        user.isTeacher = null;
        users = [...users];
    }
});

function addToTeacher(user) {
    //   var r = confirm("Press a button!");
    refStudentByTeacherList.child(selected.id).child(user.id).set(true);
    user.teacherIs = selected.id;
    console.log(`${selected.id} ${user.id}`)
}

function removeFromTeacher(user) {
    refStudentByTeacherList.child(selected.id).child(user.id).set(null);
    user.teacherIs = null;
}

function selectTeacher() {
    if (selected == 'none') return;     
    let refTeacher = refStudentByTeacherList.child(selected.id);
    refTeacher.off();
    refTeacher.on("child_added", function(snap) {
        // console.log(snap.key);
        let user = users.find(u => u.id == snap.key);
        if (!user) return;
        user.teacherIs = selected.id;
        users = [...users];        
    });

    refTeacher.on("child_removed", function(snap) {
        let user = users.find(u => u.id == snap.key);
        if (!user) return;
        if (user) {
            user.isTeacher = null;
            users = [...users];
        }        
    });

    // refStudentByTeacherList.child(selected.id).once("value", function(snap) {
    //     // console.log('selected: ' + JSON.stringify(snap))
    //     // console.log('a ' + snap)
    //     // let students = Object.values(JSON.parse(JSON.stringify(snap)));
    //     let students = JSON.parse(JSON.stringify(snap));
    //     // console.log('selected: ' + JSON.stringify(students))

    // for (const [key, value] of Object.entries(students)) { 
    //     console.log('selected: ' + key + ' ' + value);
    //     let user = users.find(u => u.id == key);
    //     if (!user) return;
    //     user.teacherIs = selected.id;
    //     users = [...users];
    // }

    // // Object.keys(snap).forEach(function(key,index) {
    // //     // key: the name of the object key
    // //     // index: the ordinal position of the key within the object 
    // //     console.log('selected: ' + JSON.stringify(key))
    // // });


    // // students.forEach((k, v => {
    // //     console.log('selected: ' + JSON.stringify(k))
    // // }));
    // });
}
</script>

<style>
button.set {
    background: white;
    color: blue;
    text-decoration: underline;
    border: 0;
    font-size: 12px;
    cursor:pointer;
}

ul.list {
  /* list-style-type: none; */
  /* margin: 0; */
  /* padding: 0; */
}

li.student {
  margin: 0;
  padding: 0;
}

.student .created {
  font-size: small;
  color: gray;
}
</style>

<h1>Head Teacher</h1>
<select bind:value={selected} on:change={selectTeacher}>
    <option disabled selected value> -- select a teacher -- </option>
	{#each teachers as teacher}
		<option value={teacher}>{teacher.name} ({teacher.email})</option>
	{/each}
</select>
<br><br>
{#if selected != 'none'}
    <input type="text" bind:value={searchQuery} placeholder="filter"/>
    <br>
    <ul class="list">
    {#each usersFiltered as user, i (user.id)}
        <li class="student">
        <span class="created">{new Date(user.created || mockCreatedDate)}</span><br>
        <b>{user.name}</b>
        {user.email ? user.email : ''} {user.isTeacher ? 'TEACHER' : ''} {user.userScore} 
        {#if user.unreadFromTeacher}T: {user.unreadFromTeacher}{/if}
        {#if user.unreadFromStudent}S: {user.unreadFromStudent}{/if}
        ({user.id})
        {#if user.teacherIs == selected.id}
            <button class="set" on:click={()=>{removeFromTeacher(user)}}>remove</button>
        {:else}
            <button class="set" on:click={()=>{addToTeacher(user)}}>add</button>
        {/if}        
        <!-- <br><br> -->
        </li>
    {/each}
    </ul>
{/if}
